import {LitElement, html, css} from 'lit';
import {msg, str} from '@lit/localize';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {repeat} from 'lit/directives/repeat.js';
import {options} from 'superagent/lib/client';

import style from '../../../../../scss/switch.scss';

@customElement('arc-switch')
export class Switch extends LitElement {
	static styles = [style];

	static properties = {
		value: {type: String},
		options: {type: Array},
		tooltip: {type: String},
		disabled: {type: Boolean},
	};


	onFlick(option) {
		this.dispatchEvent(
			new CustomEvent('switch-change', {
				bubbles: true,
				detail: {value: option.value}
			})
		);
	}

	render() {
		return html`
			<div class="switch ${this.disabled? 'disabled' : ''}" aria-disabled=${this.disabled}>
				<div class="options">
					${repeat(
						this.options,
						(option) => option,
						(option) => html`
							<button
								class="switchButton ${classMap({active: this.value === option.value})}"
								aria-disabled=${this.disabled}
								?disabled=${this.value === option.value}
								@click=${() => this.onFlick(option)}
							>
								${option.label}
							</button>
						`)}
				</div>
				${this.tooltip? html`<arc-tooltip .text=${this.tooltip}></arc-tooltip>` : ''}
			</div>
		`;
	}
}
